import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#000000",
      light: "#000000",
      dark: "#000000",
    },
    secondary: {
      main: "#808080",
      light: "#D3D3D3",
      dark: "#808080",
    },
    info: {
      main: "#000000",
      light: "#000000",
      dark: "#000000",
    },
  },
});

export default theme;
